
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import Header from "@/components/v2/page/Header.vue";
import NavGrayArrow from "@/components/icons//NavGrayArrow.vue";
import Pagination from "@/components/v2/Pagination.vue";
import TableView from "@/components/v2/table/NewTable.vue";
import MenuFilled from "@/components/icons/MenuFilled.vue";
import MoreActions from "@/components/common/MoreActionsClick.vue";
import UiButton from "@/components/button/ui-button.vue";

import Tabs from "@/components/v2/Tabs.vue";
import DownloadIcon from "@/components/icons/DownloadBlack.vue";
import moment from "moment";
import TableViewIcon from "@/components/icons/TableViewIcon.vue";
import RouteNames from "@/entities/RouteNames";
import LIST_TIMESHEET from "@/apollo/timesheet/ListTimesheet.gql";
import GET_AGGREATED_COUNT from "@/apollo/timesheet/GetAggeratedCount.gql";
import GetAggeratedCountByCompany_Manager from "@/apollo/timesheet/GetAggeratedCountByCompany_Manager.gql";
import DropDown from "@/components/v2/DropDown.vue";
import { NOTIFICATION, RESTORE_SCROLL, SAVE_SCROLL } from "@/entities/Events";
import {
  Company,
  Timesheet,
  Timesheet_Bool_Exp,
  Timesheet_Order_By,
  User,
} from "@/generated/graphql";
import DetailModal from "./DetailModal.vue";
import RejectionModal from "./RejectionModal.vue";
import UPDATE_SHEETS from "@/apollo/timesheet/UpdateTimesheets.gql";
import { MessageStatus, MessageDuration } from "@/data/notificationsMessages";
import Search from "@/components/v2/Search.vue";
import GET_COMPANIES from "@/apollo/company/GetCompaniesForDropDown.gql";
import DropdownOption from "@/entities/DropdownOption";
import Roles from "@/entities/Roles";
import DropdownFilter from "@/components/filters/DropdownFilterNew.vue";
import storage from "@/services/storage";
import {STATUS, VALUE_TO_STATUS, TIMESHEET_STATUSES} from '@/entities/TimesheetStatus';
import { hslColorFromName } from "@/utils/hslColorFromName";
import UPDATE_PROJECT_ACTIVITY_TIMES from "@/apollo/projectActivities/UpdateProjectActivitiesTime.gql";
import { checkStartOfUrl } from "@/utils";
import { secondsToHMS } from "@/utils/convertSecondsToReadable";
import { makeNameQuery, makeNameQuery1 } from "@/helpers/queryHelperFunctions";


@Component({
  components: {
    Header,
    Tabs,
    DownloadIcon,
    TableView,
    TableViewIcon,
    Pagination,
    MenuFilled,
    NavGrayArrow,
    DropDown,
    UiButton,
    DetailModal,
    RejectionModal,
    MoreActions,
    Search,
    DropdownFilter
  },
  apollo: {
    companies: {
      query: GET_COMPANIES,
      skip() { return false },
      variables() {
        return this.companiesQuery;
      },
      update(data) {
        return data.companies;
      },
    },
    timesheetList: {
      query: LIST_TIMESHEET,
      variables() {
        return {
          limit: this.limit,
          offset: this.offset,
          where: this.where,
          order_by: this.orderBy,
        };
      },
       update(data: any) {
        this.count = data.timesheet_aggregate?.aggregate?.count;
        return data.timesheet;
      },
      skip() {
        return true;
      },
    },
    // aggeratedCount: {
    //   query: GET_AGGREATED_COUNT,
    //         variables() {
    //     return this.adminAggreageWhere;
    //   },
    //   update(data: any) {
    //     const newBadges = [...this.tabs];
    //     newBadges[0].badge = data.allCount?.aggregate?.count;
    //     newBadges[1].badge = data.pendingCount?.aggregate?.count;
    //     newBadges[2].badge = data.approvedCount?.aggregate?.count;
    //     newBadges[3].badge = data.rejectedCount?.aggregate?.count;
    //     this.tabs = newBadges;
    //     return data;
    //   },
    //   skip() {
    //     return this.isManager ? true : false;
    //   },
    // },
    aggeratedManagerCount: {
      query: GetAggeratedCountByCompany_Manager,
      variables() {
        return {
          company_IDS: this.aggregateWhere?.company_IDS
        };
      },
      update(data: any) {
        const newBadges = [...this.tabs];
        newBadges[0].badge = data.allCount?.aggregate?.count;
        newBadges[1].badge = data.pendingCount?.aggregate?.count;
        newBadges[2].badge = data.approvedCount?.aggregate?.count;
        newBadges[3].badge = data.rejectedCount?.aggregate?.count;
        this.tabs = newBadges;
        return data;
      },
      skip() {
        return true;
      },
    },
  },
})
export default class InvoiceDashboard extends Vue {
  @Prop({ type: Object, required: true }) readonly currentUser!: User;
  showRejectModal = false;
  columns = [
    { label: "Resource", field: "user", sort: true },
    { label: "Total hours", field: "hours" },
    { label: "Period", field: "period", sort: true },
    { label: "Status", field: "status", sort: false },
  ];
  sid = this.$route.query.sid || "";

  timesheets: Timesheet[] = [];
  timesheetList: Timesheet[] = [];
  count: number = 0;
  tabs = [
    { name: "All", badge: 0 },
    { name: "Pending Approval", badge: 0 },
    { name: "Approved", badge: 0 },
    { name: "Rejected", badge: 0 },
  ];

  selectedItems = [];
  selectedRows = [];
  invoiceData = [];
  limit: number = Number(this.$route.query.limit || 10);
  where: Timesheet_Bool_Exp = {};
  aggregateWhere = {
    company_IDS: []
  };
  orderBy: Timesheet_Order_By[] = [];
  currentPage: number = Number(this.$route.query.page || 1);
  offset: number = this.currentPage >= 1 ? (this.currentPage  - 1) * this.limit: 0;
  activeTabIndex: number = Number(this.$route.query.tab || 0);
  sortBy = this.$route.query.sort_by || 'created_at';
  sortDirection = this.$route.query.sort_direction || null;
  companies?: Company[] = [];
  company: DropdownOption[] = [];
  companiesIds = [];

  get isPaginationDisabled(){
    return this.totalPages === 1 || this.totalPages === 0
  }
  initial(row): string {
    const firstName = row.user?.given_name;
    const lastName = row.user?.family_name;

    if (!firstName && !lastName) {
      return ''
    }

    const givenName = firstName ? firstName.trimLeft()[0] : '';
    const familyName = lastName ? lastName.trimLeft()[0] : '';
    return `${givenName}${familyName}`;
  }

  bgStyle(row): object {
      return {
          background: hslColorFromName(this.initial(row) || ""),
      };
  }


  async getFile(key: string): Promise<string> {

    return await storage.get(key)
      .then((result: any) => {
        return result;
      })
      .catch(() =>  "");
  }

@Watch("timesheetList")
async Timesheets() {
  const updatedTimesheet = [];
  if(this.timesheetList?.length){
  for (let index = 0; index < this.timesheetList.length; index++) {
    const sheet = {...this.timesheetList[index]};
    const useravatar = sheet?.user?.avatar
    const checkUrl = checkStartOfUrl(useravatar)
    if(useravatar &&  !checkUrl){
        try {
          const avatar = await this.getFile(useravatar)
          sheet.user.avatar = avatar
          updatedTimesheet.push(sheet)
        } catch (error) {
          updatedTimesheet.push(sheet)
        }
    }else{
      updatedTimesheet.push(sheet)
    }
  }
}
this.timesheets = updatedTimesheet
  }

  @Watch("companies")
  companiesTimesheets() {
    if (this.companies?.length) {
      this.companiesIds = this.companies.map(c => {
        return c.id
      })
      this.where = { ...this.where, company_id: { _in: this.companiesIds } }
      this.$apollo.queries.timesheetList.skip = false;
      this.aggregateWhere = { ...this.aggregateWhere, company_IDS: this.companiesIds }
      this.$apollo.queries.aggeratedManagerCount.skip = false;
    }
  }
getBodyRowClasses(row:any) {
  return ''
  }
  get isManager() {
    return this.currentUser.role === Roles.MANAGER
  }
  get isAdmin() {
    return this.currentUser.role === Roles.ADMIN
  }

  buildWhereForManager(id: string) {
    if ( this.isManager) {
      const comapany_id = id ? { _eq: id } : { _in: this.companiesIds }
      return { company_id: comapany_id }
    }
    if ( this.isAdmin) {
      // const adminComapnyId = this.currentUser.admin?.company_id
      const comapany_id = { _in: this.companiesIds }
      return { company_id: comapany_id }
    }
    return {}

  }
  get companiesQuery(): Object {
    let conditions: any[] = []
    if(this.isAdmin){
        conditions = [{admins: {user_id: {_eq: this.currentUser.id}}}];
      }else if (this.isManager) {

      conditions = [
        {
          managers: {
            id: { _eq: this.currentUser.manager.id },
          },
        },
      ];
    } else {

      conditions = [
        {
          contractors: {
            user_id: { _eq: this.currentUser.id },
            deleted: { _eq: false },
            approved: { _eq: true },
          },
        },
      ];
    }

    return {
      where: { _and: conditions },
      // userId: this.currentUser.id,
    };
  }
  get active_companies(): DropdownOption[] {
    return this.companies?.map((activity) => {
      return {
        name: activity.business_name,
        id: activity.id,
      };
    });
  }
  get active_company() {
    if (this.company) {
      return this.company;
    }
    return []
  }
  setCompany(input: DropdownOption[]) {
    this.company = input;
    if (input[0]?.id) {
      this.where = { ...this.where, ...this.buildWhereForManager(input[0]?.id) }
    }
  }



  @Watch("currentPage")
  @Watch("activeTabIndex")
  @Watch("limit")
  changeRouteQuery() {
      const offset = (this.currentPage - 1) * this.limit
      this.offset = offset > 0 ? offset: 0
      const {scroll, ...rest} = this.$route.query
    this.$router.push({
      name: this.$route.name, // Keep the current route name
      query: {
        ...rest, // Spread the existing query parameters
        tab: this.activeTabIndex?.toString(), // Update the 'page' parameter
        limit: this.limit?.toString(), // Update the 'limit' parameter
        page: this.currentPage?.toString(), // Update the 'page' parameter
        offset: this.offset?.toString(), // Update the 'page' parameter
      },
    });
  }
  downloadTimesheetsCSV(timesheets: Timesheet[]) {
    // Define the header for CSV file
    const csvHeader =
      "ID,Given Name,Family Name,Email,Tracked Time,Start Date,End Date\n";

    // Map timesheets to CSV rows
    const csvRows = timesheets
      .map((ts:any) => {
        // const contractorGivenName = ts.contractor.user.given_name || "";
        // const contractorFamilyName = ts.contractor.user.family_name || ""; // Assuming family_name is the correct key
        const contractorGivenName = ts.user?.given_name || "";
        const contractorFamilyName = ts.user?.family_name || ""; // Assuming family_name is the correct key
        const contractorEmail = ts.user?.email || "";
        // const trackedTime = ts.tracked_time || "";
        const trackedTime = this.convertSecondsToHoursMinutesSeconds(ts.tracked_time) || "";

        const startDate = ts.start_date || "";
        const endDate = ts.end_date; // Assuming multiple end times can exist

        // Combine data in CSV format
        return `${ts.id},"${contractorGivenName}","${contractorFamilyName}","${contractorEmail}",${trackedTime},${startDate},"${endDate}"`;
      })
      .join("\n");

    // Combine header and rows
    const csvData = csvHeader + csvRows;

    // Create a Blob with the CSV data
    const blob = new Blob([csvData], { type: "text/csv" });

    // Create a link to download the Blob
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.setAttribute("hidden", "");
    a.setAttribute("href", url);
    a.setAttribute("download", "timesheets.csv");
    document.body.appendChild(a);
    a.click();

    // Clean up
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }
  downloadAllTimesheetsCSV() {
    this.downloadTimesheetsCSV(this.timesheets)
  }
  handleSearch(value) {
    this.where  = {
      ...this.where,
      _or: [
        ...makeNameQuery1(value, ['user']),
          //       {
          // user: {_or:[{given_name: { _ilike: `%${value}%` }}, { family_name: { _ilike: `%${value}%` }}],
          //  }
          // },
        {
          project_activity_times: {
            project_activity: { title: { _ilike: `%${value}%` } },
          },
        },
        {
          project_activity_times: {
            project_activity: { project: { name: { _ilike: `%${value}%` } } },
          },
        },

      ],
    };
  }

  get contructOrderBy() {
    const orderBy = {is_new: 'desc'}
    let orderby = [];
    if (this.sortBy === "user") {
      orderby = [
        {
          ...orderBy,
          user: {
            given_name: this.sortDirection,
          },

        },
      ];
    } else if (this.sortBy === "period") {
      orderby = [
        {
          ...orderBy,
          start_date: this.sortDirection,
        },
      ];
    } else if (this.sortBy === "status") {
      orderby = [
        {...orderBy,
          status: this.sortDirection,
        },
      ];
    }else if(this.sortBy === 'created_at'){
      orderby = [
        {...orderBy,
          created_at: 'desc'
        },
      ];
    }else {
      orderby = [orderBy];

    }
    return orderby;
  }
  handleSort({ sortBy, sortDirection }) {
    //order by
    this.sortBy = sortBy;
    this.sortDirection = sortDirection;
    const {scroll, ...rest} = this.$route.query
    this.$router.push({
      name: this.$route.name, // Keep the current route name
      query: {
        ...rest, // Spread the existing query parameters
        sort_by: sortBy, // Update the 'page' parameter
        sort_direction: sortDirection,
      },
    });
    this.orderBy = this.contructOrderBy;
  }

  onClose() {
    this.sid = "";
    this.$router.push({
      name: this.$route.name, // Keep the current route name
      query: {
        ...this.$route.query,
        sid: undefined,
        scroll: '0'
      },
    });
  }
  onProjectClick(row){
     this.sid = "";
    this.$router.push({
      name: RouteNames.PROJECT_ACTIVITY,
       params: {
        id: row.project_activity.project.id,
      },
    });
  }

  openSheetDetail( id: string) {
          // this.$eventBus.emit(SAVE_SCROLL);
          this.$router.push({
            name: this.$route.name, // Keep the current route name
            query: {
              ...this.$route.query,
              sid: id,
              scroll: '0'
            },

          });
    this.sid = id;
  }
  @Watch("activeTabIndex")
  onTabChange() {
    const newValue = this.buildWhere;
    this.where = newValue;
  }

  get loading(): boolean {
    return this.$apollo.queries.timesheetList?.loading || this.$apollo.queries.companies?.loading;
  }
  handleCloseRejectModal() {
    this.showRejectModal = false;
  }

  handleOpenRejectModal() {
        const isApproveOrRejectExist =  this.selectedItems?.find(row => row.status === TIMESHEET_STATUSES.APPROVED || row.status === TIMESHEET_STATUSES.REJECTED);
    // if (isApproveOrRejectExist) {
    //           this.$eventBus.emit(NOTIFICATION, {
    //       status: MessageStatus.ERROR,
    //       title: "Please Remove Approved and Rejected Timesheet from the items.",
    //       duration: MessageDuration.DEFAULT,
    //       // message: `You rejected hours for ${this.selectedRows.length || 0} resources.`,
    //     });

    //     return;
    // }
    this.showRejectModal = true;
  }

  handleRefectTimesheet() {
    this.$apollo.queries.timesheetList.refetch();
    if (this.isManager) {
      this.$apollo.queries.aggeratedManagerCount.refetch()
    }
  }
  async handleApproveRejectProjectActity_times(status: string){
            return await this.$apollo
      .mutate({
        mutation: UPDATE_PROJECT_ACTIVITY_TIMES,
        variables: {
          where: {timesheet_id: {_in: this.selectedRows}},
          set: {
            status: status},
          },
      }).catch(e => console.log('error'))
  }
  async handleApproved(value) {

    const isApproveOrRejectExist =  this.selectedItems.find(row => row.status === TIMESHEET_STATUSES.APPROVED || row.status === TIMESHEET_STATUSES.REJECTED);
    // if (isApproveOrRejectExist) {
    //           this.$eventBus.emit(NOTIFICATION, {
    //       status: MessageStatus.ERROR,
    //       title: "Please Remove Approved and Rejected Timesheet from the items.",
    //       duration: MessageDuration.DEFAULT,
    //       // message: `You rejected hours for ${this.selectedRows.length || 0} resources.`,
    //     });

    //     return;
    // }

    return await this.$apollo
      .mutate({
        mutation: UPDATE_SHEETS,
        variables: {
          set: {
            status: "APPROVED",
            is_new: false,

          },
          ids: this.selectedRows,
        },
      })
      .then(async () => {
          await this.handleApproveRejectProjectActity_times("APPROVED")
        this.handleRefectTimesheet();
        this.$eventBus.emit(NOTIFICATION, {
          status: MessageStatus.SUCCESS,
          title: "Successfully Approved hours",
          duration: MessageDuration.MEDIUM,
          message: `You approved time submitted by ${this.selectedRows?.length || 0} separate resources.`,
        });
        this.selectedRows = [];
        this.selectedItems = []
      });
  }

  async handleReject(value) {
    const isnoteExist = (value.note || '').trim()
    if(value.reason === 'Other' && !isnoteExist){
       this.$eventBus.emit(NOTIFICATION, {
          status: MessageStatus.INFO,
          title: "Please Provide a Reason.",
          duration: MessageDuration.MEDIUM,
        });
        return;
    }
    const isApproveOrRejectExist =  this.selectedItems.find(row => row.status === TIMESHEET_STATUSES.APPROVED || row.status === TIMESHEET_STATUSES.REJECTED);
    // if (isApproveOrRejectExist) {
    //           this.$eventBus.emit(NOTIFICATION, {
    //       status: MessageStatus.ERROR,
    //       title: "Please Remove Approved and Rejected Timesheet from the items.",
    //       duration: MessageDuration.MEDIUM,
    //       // message: `You rejected hours for ${this.selectedRows.length || 0} resources.`,
    //     });

    //     return;
    // }
    return await this.$apollo
      .mutate({
        mutation: UPDATE_SHEETS,
        variables: {
          set: {
            status: "REJECTED",
            // note: this.note,
            is_new: false,
            reject_reason:  value.note,
          },
          ids: this.selectedRows,
        },
      })
      .then(async () => {
        await this.handleApproveRejectProjectActity_times("REJECTED")
        this.handleRefectTimesheet();
        this.$eventBus.emit(NOTIFICATION, {
          status: MessageStatus.SUCCESS,
          title: "Successfully rejected hours",
          duration: MessageDuration.MEDIUM,
          message: `You rejected hours for ${this.selectedRows.length || 0} resources.`,
        });
        this.handleCloseRejectModal();
        this.selectedRows = [];
        this.selectedItems = []
      });
  }

  handleDownloadSelected() {
    this.downloadTimesheetsCSV(
      this.timesheets.filter((ts) => this.selectedRows.includes(ts.id))
    );
  }

  formatNumber(value) {
    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  }

  get buildWhere(): Timesheet_Bool_Exp {
    let where;
    let sheetStatus = { status: { _neq: "UNSUBMITTED" } }
    if (
      this.activeTabIndex &&
      this.activeTabIndex > 0 &&
      this.activeTabIndex < this.tabs.length
    ) {
      const status = VALUE_TO_STATUS[this.tabs[this.activeTabIndex].name];
      where = {
        _and: {
          status: { _eq: status, _neq: "UNSUBMITTED" }
        },
      };
      sheetStatus = where;
    }
    where = { ...sheetStatus, ...this.buildWhereForManager(this.company[0]?.id) }

    return where;
  }
  created() {
    this.where = this.buildWhere;
    this.orderBy = this.contructOrderBy;

  }
  changePage(direction) {
    const nextPage = this.currentPage + direction;
    if (nextPage > 0 && nextPage <= this.totalPages) {
      //set limit in query
      this.currentPage = nextPage;
    }
  }
  get totalPages() {
    return Math.ceil(this.count / this.limit);
  }
  onLimitChange(limit) {
    const lmit = this.limit;
    this.limit = Number(limit);
    if(lmit <  this.limit){
      const newPages =  Math.ceil(this.count / this.limit);
      if(this.currentPage >  newPages){
        this.currentPage = newPages;
      }
    }
  }
  gettimeRangeFormat(start, end) {
    // const startDate = start ? moment(start).format("MMM DD") : "";
    // const endDate = end ? moment(end).format("MMM DD, YYYY") : "";
    const startDate = start ? moment(start).format("DD MMM, YYYY") : "";
    const endDate = end ? moment(end).format("DD MMM, YYYY") : "";
    return `${startDate} -
      ${endDate}`;
  }

  status(value) {
    return STATUS[value];
  }

  userFullname(user): any {
    const givenName = user?.given_name ?? "";
    const familyName = user?.family_name ?? "";
    return `${givenName} ${familyName}`;
  }
  userShortname(user): any {
    const givenName = user?.given_name ?? "";
    const familyName = user?.family_name ?? "";
    return `${givenName.charAt(0)} ${familyName.charAt(0)}`;
  }
  convertSecondsToHoursMinutesSeconds(seconds) {
    if (typeof seconds !== "number" || isNaN(seconds) || seconds < 0) {
      return "0 s";
    }
    const time = secondsToHMS({duration: seconds});
    const {hours: hs , minutes: ms, seconds: sc} = time;
    let result = "";
    if (hs > 0) {
      result += hs + " h ";
    }
    if (ms > 0) {
      result += ms + " m ";
    }
    if (sc > 0) {
      result += sc+ " s";
    }
    if (result === "") {
      result = "0 s";
    }

    return result;
  }
}
